import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLink } from '@fortawesome/pro-solid-svg-icons';

export default function MediaLinks({ mediaLinksFormFields, onFormChange }) {
  return (
    <div>
      <h6 className="mb-4">
        <FontAwesomeIcon className="text-accent me-2" icon={faLink} />
        Links
      </h6>

      <div className="form-vertical-field-container">
        <div className="form-group">
          <label className="form-label">Video URL</label>
          <div className="form-input-container">
            <input
              className="form-control"
              id="property_you_tube_url"
              placeholder="Enter video url from youtube or vimeo"
              value={mediaLinksFormFields.youTubeUrl}
              onChange={e => onFormChange('youTubeUrl', e.target.value)}
            />
          </div>
        </div>

        <div className="form-group">
          <label className="form-label">Matterport Showcase Link</label>
          <div className="form-input-container">
            <input
              className="form-control"
              id="property_matterport_url"
              placeholder="Enter Matterport Showcase link"
              value={mediaLinksFormFields.matterportUrl}
              onChange={e => onFormChange('matterportUrl', e.target.value)}
            />
          </div>
        </div>

        <div className="form-group">
          <label className="form-label">Virtual Tour Link</label>
          <div className="form-input-container">
            <input
              className="form-control"
              id="property_realvision_url"
              placeholder="Enter virtual tour link (non-Matterport)"
              value={mediaLinksFormFields.realvisionUrl}
              onChange={e => onFormChange('realvisionUrl', e.target.value)}
            />
          </div>
        </div>

        <div className="form-group">
          <label className="form-label">Land id Embed Map Code</label>
          <div className="form-input-container">
            <input
              className="form-control"
              id="property_mapright_embed_code"
              placeholder="Enter Land id Embed Map code"
              value={mediaLinksFormFields.maprightEmbedCode}
              onChange={e => onFormChange('maprightEmbedCode', e.target.value)}
            />
          </div>
        </div>

        <div className="form-group">
          <label className="form-label">TerraStride Embed Map Code</label>
          <div className="form-input-container">
            <input
              className="form-control"
              id="property_terrastride_embed_code"
              placeholder="Enter TerraStride Embed Map code"
              value={mediaLinksFormFields.terrastrideEmbedCode}
              onChange={e => onFormChange('terrastrideEmbedCode', e.target.value)}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

MediaLinks.propTypes = {
  mediaLinksFormFields: PropTypes.shape({
    youTubeUrl: PropTypes.string,
    matterportUrl: PropTypes.string,
    realvisionUrl: PropTypes.string,
    maprightEmbedCode: PropTypes.string,
    terrastrideEmbedCode: PropTypes.string
  }).isRequired,
  onFormChange: PropTypes.func.isRequired
};
